import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Dialog, Grid } from "@mui/material";
import Signifier from "../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { getEvents } from "./EventsService";
import SortableTable from "../../App/Components/Table/SortableTable";
import EventsTableCell from "./Components/EventsTableCell";
import { convertDateWithTime } from "../../App/Helpers/DateConverters";
import AddEventModal from "./Components/AddEventModal";

function EventsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "80%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [includeinActive, setIncludeinActive] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);

  const [eventModel, setEventModel] = useState({});

  const columns = [
    { label: "Title", propName: "title" },
    { label: "Start Date", propName: "startDate" },
    { label: "End Date", propName: "endDate" },
    { label: "Active", propName: "displayIsActive" },
    { label: "Accepts RSVP", propName: "displayHasRsvp" },
    { label: "# of RSVP", propName: "displayRsvpLength" },
    { label: "Deactivate", propName: "" },
  ];

  useEffect(() => {
    setLoading(true);
    if (selectCareersClient !== null) {
      getEvents(selectCareersClient.id, includeinActive).then((response) => {
        response.eventVenues = [{ name: "+ Add New" }].concat(
          response.eventVenues
        );
        response.eventTypes = [{ name: "+ Add New" }].concat(
          response.eventTypes
        );
        response.eventSponsors.forEach(
          (row) =>
            (row.imagePath = "data:" + row.contentType + ";base64," + row.logo)
        );
        response.events?.forEach((row) => {
          row.displayIsActive = row.isActive ? "Yes" : "No";
          row.displayHasRsvp = row.hasRsvp ? "Yes" : "No";
          row.displayRsvpLength = row.eventEventRsvpXrefs.length;
          row.startDate = convertDateWithTime(row.startDate);
          row.endDate = convertDateWithTime(row.endDate);
          row.sponsors = response.eventSponsors;
          row.types = response.eventTypes;
          row.venues = response.eventVenues;
          row.timeZones = response.timeZonesCollection;
        });
        setEventModel(response);
        setTableData(response.events);
        setLoading(false);
      });
    }
  }, [selectCareersClient, includeinActive]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">{selectCareersClient.shortName} Events</h1>
        <div className={classes.root}>
          {selectCareersClient === null ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Button
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    marginRight: "20px",
                  }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => setOpenAddModal(true)}
                >
                  Add Event
                </Button>
                <Button
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => setIncludeinActive(!includeinActive)}
                >
                  {includeinActive ? "Exclude Inactive" : "Include Inactive"}
                </Button>
              </Grid>
              <SortableTable
                columns={columns}
                tableData={tableData}
                rowComponent={EventsTableCell}
                loading={loading}
                setTableData={setTableData}
                defaultSortIndex={1}
                reverse={true}
              />
            </Grid>
          )}
        </div>
        <Dialog
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
          fullWidth
          maxWidth="md"
        >
          <AddEventModal
            openModal={setOpenAddModal}
            client={selectCareersClient}
            setShowSignifier={setShowSignifier}
            setResponseMessage={setResponseMessage}
            setShowError={setShowError}
            setTableData={setTableData}
            eventModel={eventModel}
            setEventModel={setEventModel}
            includeinActive={includeinActive}
          />
        </Dialog>
      </div>
    </>
  );
}

export default EventsPage;
